import { hseAxiosInstance } from "@dashboard/api/axiosInstance";

export type HseSummaryMetric = {
    total: number;
};

type HseSummaryMetrics = {
    tasks: HseSummaryMetric & { needsAttention: number };
    risks: HseSummaryMetric;
    opportunities: HseSummaryMetric;
    issues: HseSummaryMetric & { overdue: number };
    improvements: HseSummaryMetric;
};

type MetricsIssueByCustomer = {
    issues_by_categories: Record<string, number> | [];
    issues_by_status: Record<string, number> | [];
};

type HseSummaryLinks = {
    improvements: string;
    issues: string;
    risks: string;
    opportunities: string;
    tasks: string;
};

export type HseSummaryData = {
    userId: number;
    generatedAt: Date;
    metrics: HseSummaryMetrics;
    metricsIssueByCustomer: MetricsIssueByCustomer;
    links: HseSummaryLinks | [];
};

interface ApiResponse {
    data: HseSummaryData[];
}

export const getHseSummary = async (): Promise<HseSummaryData> => {
    const response = await hseAxiosInstance.get<ApiResponse>("/compublish/summary");
    if (!response.data.data || response.data.data.length === 0) {
        throw new Error("No summary data available");
    }
    return response.data.data[0];
};
